import React, { useState } from 'react';
import { Card } from './ui/Card';
import { Badge } from './ui/Badge';
import { Button } from './ui/Button';
import { CalculatorIcon } from 'lucide-react';
export function CalculatorPreview() {
  const [amount, setAmount] = useState(500000);
  const [term, setTerm] = useState(36);
  const monthlyPayment = Math.round(amount * 0.025);
  const totalDeduction = Math.round(amount * 1.16);
  const taxSavings = Math.round(totalDeduction * 0.3);
  return <section id="calculadora" className="py-20 px-4 sm:px-6 lg:px-8 bg-white" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-12" data-id="element-3">
          <Badge variant="primary" className="mb-4" data-id="element-4">
            Calculadora
          </Badge>
          <h2 className="text-3xl sm:text-4xl font-bold text-slate-900 mb-4" data-id="element-5">
            Calcula tu arrendamiento
          </h2>
          <p className="text-xl text-slate-600" data-id="element-6">
            Descubre cuánto puedes ahorrar en impuestos
          </p>
        </div>

        <Card className="max-w-3xl mx-auto" data-id="element-7">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-8">
            {/* Inputs */}
            <div className="space-y-6" data-id="element-9">
              <div data-id="element-10">
                <label className="block text-sm font-semibold text-slate-900 mb-2" data-id="element-11">
                  Valor del activo
                </label>
                <div className="relative" data-id="element-12">
                  <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-500 font-medium" data-id="element-13">
                    $
                  </span>
                  <input type="number" value={amount} onChange={e => setAmount(Number(e.target.value))} className="w-full pl-8 pr-4 py-3 border-2 border-slate-200 rounded-lg focus:border-primary focus:outline-none text-lg font-semibold" data-id="element-14" />
                </div>
                <input type="range" min="100000" max="5000000" step="50000" value={amount} onChange={e => setAmount(Number(e.target.value))} className="w-full mt-3" data-id="element-15" />
              </div>

              <div data-id="element-16">
                <label className="block text-sm font-semibold text-slate-900 mb-2" data-id="element-17">
                  Plazo (meses)
                </label>
                <select value={term} onChange={e => setTerm(Number(e.target.value))} className="w-full px-4 py-3 border-2 border-slate-200 rounded-lg focus:border-primary focus:outline-none text-lg font-semibold" data-id="element-18">
                  <option value={12} data-id="element-19">12 meses</option>
                  <option value={24} data-id="element-20">24 meses</option>
                  <option value={36} data-id="element-21">36 meses</option>
                  <option value={48} data-id="element-22">48 meses</option>
                  <option value={60} data-id="element-23">60 meses</option>
                </select>
              </div>
            </div>

            {/* Results */}
            <div className="bg-gradient-to-br from-primary-50 to-primary-100 rounded-xl p-6 space-y-4" data-id="element-24">
              <div data-id="element-25">
                <p className="text-sm text-primary-700 font-medium mb-1" data-id="element-26">
                  Pago mensual estimado
                </p>
                <p className="text-3xl font-bold text-primary-900" data-id="element-27">
                  ${monthlyPayment.toLocaleString('es-MX')}
                </p>
              </div>

              <div className="border-t border-primary-200 pt-4" data-id="element-28">
                <p className="text-sm text-primary-700 font-medium mb-1" data-id="element-29">
                  Deducción total
                </p>
                <p className="text-2xl font-bold text-primary-900" data-id="element-30">
                  ${totalDeduction.toLocaleString('es-MX')}
                </p>
              </div>

              <div className="bg-white rounded-lg p-4" data-id="element-31">
                <div className="flex items-center gap-2 mb-2" data-id="element-32">
                  <svg className="w-5 h-5 text-success" fill="currentColor" viewBox="0 0 20 20" data-id="element-33">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" data-id="element-34" />
                  </svg>
                  <p className="text-sm font-semibold text-slate-900" data-id="element-35">
                    Ahorro fiscal estimado
                  </p>
                </div>
                <p className="text-2xl font-bold text-success" data-id="element-36">
                  ${taxSavings.toLocaleString('es-MX')}
                </p>
                <p className="text-xs text-slate-600 mt-1" data-id="element-37">
                  Basado en tasa ISR del 30%
                </p>
              </div>
            </div>
          </div>

          <div className="mt-6 pt-6 border-t border-slate-200" data-id="element-38">
            <Button className="w-full" size="lg" data-id="element-39">
              <CalculatorIcon className="w-5 h-5" data-id="element-40" />
              Obtener cotización personalizada
            </Button>
            <p className="text-xs text-slate-500 text-center mt-3" data-id="element-41">
              *Cálculo estimado. La tasa final depende del perfil crediticio.
            </p>
          </div>
        </Card>
      </div>
    </section>;
}